import { FinanceService } from './finance.service'

export const getInvoiceFileLink = async (
  invoiceId: string
): Promise<{ isSuccess: boolean; url?: string }> => {
  const { ok: isSuccess, data } = await FinanceService.getInvoiceFile({
    invoiceId
  })
  const url = data?.url

  return { isSuccess, url }
}
